import HttpResponse from "../../../../../utils/http/http.response";

export enum BillingsCargoTaxiDetailsResponseDataBillingStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
  REOPENED = "REOPENED",
}

export type BillingsCargoTaxiDetailsResponseDataContractCargoCompany = {
  companyName: string;
  displayName: string;
};

export enum BillingsCargoTaxiDetailsResponseDataContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type BillingsCargoTaxiDetailsResponseDataContract = {
  allowChargeWhileApproaching: boolean;
  allowChargeWhileReturning: boolean;
  allowChargeDuringRide: boolean;
  discountLimit: number;
  cargoCompany: BillingsCargoTaxiDetailsResponseDataContractCargoCompany;
  model: BillingsCargoTaxiDetailsResponseDataContractBillingModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
};

export type BillingsCargoTaxiDetailsResponseDataBillingNode = {
  id: string;
  nodeId: string;
  checkoutEventId?: string;
  lat: number;
  lon: number;
  description: string;
  editableCoordinated: boolean;
  checkoutDate?: Date;
  plannedDate?: Date;
  orderId?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
};

export type BillingsCargoTaxiDetailsResponseDataCargoOrder = {
  id: string;
  humanId: number;
};

export enum BillingsCargoTaxiDetailsResponseDataBillingContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  DISCOUNT_OPTIMIZATION = "DISCOUNT_OPTIMIZATION",
  DISCOUNT_BEING_LATE = "DISCOUNT_BEING_LATE",
  DISCOUNT_INCOMPATIBLE_CAR = "DISCOUNT_INCOMPATIBLE_CAR",
  DISCOUNT_OTHER = "DISCOUNT_OTHER",
  CONTRACT_CORRECTION_PERCENTAGE = "CONTRACT_CORRECTION_PERCENTAGE",
}

export type BillingsCargoTaxiDetailsResponseDataBillingContributionBaseAmount =
  {
    type: BillingsCargoTaxiDetailsResponseDataBillingContributionType.BASE_AMOUNT;
    comment?: string;
    distance: number;
    rate: number;
  };

export type BillingsCargoTaxiDetailsResponseDataBillingContributionChargeHaltings =
  {
    type: BillingsCargoTaxiDetailsResponseDataBillingContributionType.CHARGE_HALTING;
    comment?: string;
    distance: number;
    amount: number;
  };

export type BillingsCargoTaxiDetailsResponseDataBillingContributionContractCorrectionPercentage =
  {
    type: BillingsCargoTaxiDetailsResponseDataBillingContributionType.CONTRACT_CORRECTION_PERCENTAGE;
    comment?: string;
    percentage: number;
    amount: number;
  };

export type BillingsCargoTaxiDetailsResponseDataBillingContributionDiscountOptimization =
  {
    type: BillingsCargoTaxiDetailsResponseDataBillingContributionType.DISCOUNT_OPTIMIZATION;
    comment?: string;
    amount: number;
  };

export type BillingsCargoTaxiDetailsResponseDataBillingContributionDiscountBeingLate =
  {
    type: BillingsCargoTaxiDetailsResponseDataBillingContributionType.DISCOUNT_BEING_LATE;
    comment?: string;
    amount: number;
  };

export type BillingsCargoTaxiDetailsResponseDataBillingContributionDiscountIncompatibleCar =
  {
    type: BillingsCargoTaxiDetailsResponseDataBillingContributionType.DISCOUNT_INCOMPATIBLE_CAR;
    comment?: string;
    amount: number;
  };

export type BillingsCargoTaxiDetailsResponseDataBillingContributionDiscountOther =
  {
    type: BillingsCargoTaxiDetailsResponseDataBillingContributionType.DISCOUNT_OTHER;
    comment?: string;
    amount: number;
  };

export type BillingsCargoTaxiDetailsResponseDataBillingContribution =
  | BillingsCargoTaxiDetailsResponseDataBillingContributionBaseAmount
  | BillingsCargoTaxiDetailsResponseDataBillingContributionChargeHaltings
  | BillingsCargoTaxiDetailsResponseDataBillingContributionContractCorrectionPercentage
  | BillingsCargoTaxiDetailsResponseDataBillingContributionDiscountOptimization
  | BillingsCargoTaxiDetailsResponseDataBillingContributionDiscountBeingLate
  | BillingsCargoTaxiDetailsResponseDataBillingContributionDiscountIncompatibleCar
  | BillingsCargoTaxiDetailsResponseDataBillingContributionDiscountOther;

export type BillingsCargoTaxiDetailsResponseData = {
  status: BillingsCargoTaxiDetailsResponseDataBillingStatus;
  passengers: string[];
  contract: BillingsCargoTaxiDetailsResponseDataContract;
  baseAmountValue: number;
  amountForChargeHighways: number;
  amountForChargeHaltings: number;
  contractCorrectionPercentage: number;
  sumOfDiscounts: number;
  amountForDistance: number;
  allContributionsAmount: number;
  distance: number;
  date: Date;
  billingNodes: BillingsCargoTaxiDetailsResponseDataBillingNode[];
  cargoOrder: BillingsCargoTaxiDetailsResponseDataCargoOrder;
  planEntryId: string;
  billingContributions: BillingsCargoTaxiDetailsResponseDataBillingContribution[];
};

type BillingsCargoTaxiDetailsResponse =
  HttpResponse<BillingsCargoTaxiDetailsResponseData>;

export default BillingsCargoTaxiDetailsResponse;
